
/**
 * Drawer for cart extended from generic drawer element
 */

import Drawer from './drawer';

class DrawerCart extends Drawer {
    constructor() {
        super();
        this.MobileMenu = document.querySelector("w3-navigation-mobile w3-drawer");
        this.drawerBtnsClose = document.querySelectorAll('.js-drawer-cart-close');
    }

    connectedCallback() {
        super.connectedCallback();
        this.drawerBtnsClose.forEach((el) => el.addEventListener("click", () => {
            this.removeAttribute("style");
            this.classList.remove("drawer--visible");
            this.closeDrawer();
        }))
    }

    openDrawer() {
        if (this.MobileMenu?.classList.contains("drawer--visible")) {
            this.MobileMenu?.classList.remove("drawer--visible")
            this.classList.add("drawer--visible");
            this.style.display = "block";
            return;
        } else {
            this.showDrawer();
        }
    }

    showDrawer() {
        setTimeout(() => {
            document.body.classList.add('cart-drawer--visible');
        }, 50);
        super.openDrawer() 
    }

    closeDrawer() {
        setTimeout(() => {
            document.body.classList.remove('cart-drawer--visible');
        }, 300);
        super.closeDrawer()
    }

    bindEvents() {
        document.addEventListener('theme:drawer:cart:open', (e) => {
            this.openDrawer();
        });

        super.bindEvents()
    }
}

customElements.define('w3-drawer-cart', DrawerCart);
